import React, { useState, useEffect } from "react"
import tw from "twin.macro"

const Eloqua = ({ heading, isMobile }) => {
    const [submit, setSubmit] = useState(false)
    const [dropdownValueJour, setDropdownValueJour] = useState("")
    const [dropdownValueHoraire, setDropdownValueHoraire] = useState("")
    const [optIn, setOptIn] = useState("Opt-In")
    const [checked, setChecked] = useState(true)
    const [cid, setCid] = useState("")
    const formHandler = (e) => {
        setSubmit(true)
        e.preventDefault()
        let form_el = e.target
        let data = ""
        let input = form_el.querySelectorAll("input, textarea")
        for (let i = 0; i < input.length; i++) {
            let value = input[i].value
            let name = input[i].name
            data =
                data +
                "&" +
                encodeURIComponent(name) +
                "=" +
                encodeURIComponent(value)
        }
        data = data.substring(1)
        const xhr = new XMLHttpRequest()
        xhr.open(
            "POST",
            "https://marketingplatform.api.intuit.com/v1/eloqua/lead/"
        )
        xhr.setRequestHeader(
            "Authorization",
            "Intuit_APIKey intuit_apikey=prdakyresPssbUgTk0rlcx3K9v9Q6tFvxIDs0i67"
        )
        xhr.setRequestHeader(
            "Content-Type",
            "application/x-www-form-urlencoded; charset=UTF-8"
        )
        xhr.responseType = "json"
        xhr.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                window.location.href = xhr.response.data.forward
            }
        }
        xhr.send(data)
    }

    const changeHandler = (e) => {
        setChecked(!checked)
        if (e.target.value === "Opt-In") {
            setOptIn("")
        } else {
            setOptIn("Opt-In")
        }
    }

    const handleSelectJour = (e)=> {
        setDropdownValueJour(e.target.value)
    }

    const handleSelectHoraire = (e)=> {
        setDropdownValueHoraire(e.target.value)
    }    

    useEffect(() => {

        const cid = window.location.href;
        setCid(cid);

    });
    return (
        <>
            <form
                onSubmit={formHandler}
                method="post"
                name="FR_SMB_contact"
                action="https://marketingplatform.api.intuit.com/v1/eloqua/lead/"
                acceptCharset="UTF-8"
                encType="application/x-www-form-urlencoded"
                css={tw`bg-white m-4 p-4`}
                css={{boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.2)", borderRadius: "4px"}}

            >
                <input
                    type="hidden"
                    name="elqFormName"
                    value="FR_TeleSales_Contact_Form"
                />
                {
                    cid && (
                        <input
                            type="hidden"
                            name="sf_cid"
                            id="sf_cid"
                            value={cid}
                    />
                    )
                }

                
                {isMobile && (
                    <input type="hidden" name="sf_isMobile" value="yes" />
                )}
                <input type="hidden" name="elqSiteId" value="113755760" />
                <input type="hidden" name="elqCampaignId" value="1544" />
                <input
                    type="hidden"
                    name="elqCustomerGUID"
                    id="elqCustomerGUID"
                    value=""
                />
                <input
                    type="hidden"
                    name="elqAction"
                    value="https://s113755760.t.eloqua.com/e/f2"
                />
                <input type="hidden" name="ownerType" value="EMAIL" />
                <input type="hidden" name="resource" value="email" />

                <div css={tw`my-2`}>
                    <input
                        placeholder="Jour"
                        id="sf_day"
                        type="text"
                        name="sf_day"
                        value={dropdownValueJour}
                        maxLength="35"
                        css={tw`hidden border border-grey-600 border-solid rounded p-2 w-full`}
                        data-action={"info_entered"}
                        data-object={"sf_day"}
                        data-ui-access-point={"TS Contact Form"}
                        data-ui-action={"input"}
                        data-ui-object={"form_field"}
                        data-ui-object-detail={"Day"}   
                    />
                </div> 

                <div>
                    <select
                        onChange={handleSelectJour}
                        css={tw`text-grey-800 border border-grey-600 border-solid rounded w-full my-2 p-1`} 
                        id="fake_message_day" 
                        name="fake_message_day" 
                        required={true}
                        data-action={"info_entered"}
                        data-object={"sf_day"}
                        data-ui-access-point={"TS Contact Form"}
                        data-ui-action={"interacted"}
                        data-ui-object={"form_field"}
                        data-ui-object-detail={"Day"}                          
                    >
                        <option disabled selected hidden value="">Jour</option>
                        <option value="Lundi">Lundi</option>
                        <option value="Mardi">Mardi</option>
                        <option value="Mercredi">Mercredi</option>
                        <option value="Jeudi">Jeudi</option>
                        <option value="Vendredi">Vendredi</option>
                        </select>
                </div>                               

                <input
                        placeholder="Jour"
                        value={dropdownValueJour}
                        id="sf_day"
                        type="text"
                        name="sf_day"
                        css={tw`hidden border border-grey-600 border-solid rounded p-2 w-full`}
                /> 

                <div>
                    <select
                        onChange={handleSelectHoraire}
                        css={tw`text-grey-800 border border-grey-600 border-solid rounded w-full my-2 p-1`} 
                        id="fake_message_hour" 
                        name="fake_message_hour" 
                        required={true}
                        data-action={"info_entered"}
                        data-object={"sf_time"}
                        data-ui-access-point={"TS Contact Form"}
                        data-ui-action={"interacted"}
                        data-ui-object={"form_field"}
                        data-ui-object-detail={"Hour"}                          
                    >
                        <option disabled selected hidden value="">Horaire</option>
                        <option value="10h-11h">10h-11h</option>
                        <option value="11h-12h">11h-12h</option>
                        <option value="14h-15h">14h-15h</option>
                        <option value="15h-16h">15h-16h</option>
                        <option value="16h-17h">16h-17h</option>
                        </select>
                </div>                    

                <div css={tw`my-2`}>
                    <input
                        value={dropdownValueHoraire}
                        placeholder="Horaire"
                        id="sf_time"
                        type="text"
                        name="sf_time"
                        maxLength="35"
                        css={tw`hidden border border-grey-600 border-solid rounded p-2 w-full`}
                    />
                </div>                

                <div css={tw`my-2`}>
                    <input
                        className="inputOn"
                        placeholder="Téléphone (+33 (0)x xx xx xx x)"
                        id="sf_phone"
                        type="text"
                        name="sf_phone"
                        maxLength="35"
                        pattern="[+0-9\s]+"
                        required={true}
                        css={tw`border border-grey-600 border-solid rounded p-2 w-full`}
                        data-action={"info_entered"}
                        data-object={"sf_phone"}
                        data-ui-access-point={"TS Contact Form"}
                        data-ui-action={"input"}
                        data-ui-object={"form_field"}
                        data-ui-object-detail={"Téléphone"}                        
                    />
                </div>

                <div css={tw`my-2`}>
                    <input
                        placeholder="Prénom, Nom"
                        id="sf_firstName"
                        type="text"
                        name="sf_firstName"
                        maxLength="35"
                        required={true}
                        css={tw`border border-grey-600 border-solid rounded p-2 w-full`}
                        data-action={"info_entered"}
                        data-object={"sf_firstName"}
                        data-ui-access-point={"TS Contact Form"}
                        data-ui-action={"input"}
                        data-ui-object={"form_field"}
                        data-ui-object-detail={"Prénom, Nom"}   
                    />
                </div>                

                <div css={tw`my-2`}>
                    <input
                        className="inputOn"
                        placeholder="Société"
                        id="sf_company"
                        type="text"
                        name="sf_company"
                        maxLength="100"
                        required={true}
                        css={tw`border border-grey-600 border-solid rounded p-2 w-full`}
                        data-action={"info_entered"}
                        data-object={"sf_company"}
                        data-ui-access-point={"TS Contact Form"}
                        data-ui-action={"input"}
                        data-ui-object={"form_field"}
                        data-ui-object-detail={"Société"}                          
                    />
                </div>

                <div css={tw`my-2`}>
                    <input
                        placeholder="E-mail"
                        id="sf_referral"
                        type="email"
                        name="sf_referral"
                        maxLength="35"
                        pattern="[^@]+@[^@]+\.[a-zA-Z]{2,6}"
                        required={true}
                        css={tw`border border-grey-600 border-solid rounded p-2 w-full`}
                        data-action={"info_entered"}
                        data-object={"sf_referral"}
                        data-ui-access-point={"TS Contact Form"}
                        data-ui-action={"input"}
                        data-ui-object={"form_field"}
                        data-ui-object-detail={"E-mail"}                          
                    />
                </div>

                <div css={tw`-mb-2 pt-2`}>
                    <label css={tw`text-xs flex`}>
                        <input
                            // onClick={optInToggler.bind(this)}
                            onChange={changeHandler}
                            name="sf_optIn"
                            id="sf_optIn"
                            type="checkbox"
                            value={optIn}
                            checked={checked}
                            data-action={"info_entered"}
                            data-object={"sf_optIn"}
                            data-ui-access-point={"SMB Contact Form"}
                            data-ui-action={"text_field"}
                            data-ui-object={"form_field"}
                            data-ui-object-detail={"Opt In"}                              
                        />
                        <span css={tw`text-grey-600 leading-tight ml-1`}>
                            Les informations récoltées dans ce formulaire serons
                            utilisées pour vous recontacter. Nous ne partageons
                            pas vos données avec d’autres entités. Vous pourrez
                            vous désinscrire à tout moment grâce aux liens de
                            désinscription présents dans nos e-mails.
                        </span>
                    </label>
                </div>

                <div>
                    <input
                        type="submit"
                        // className={submit && "spinner"}
                        disabled={submit ? true : false}
                        data-wa-link="mobileContactFrom"
                        value={heading || "Envoyer"}
                        css={tw`btn btn-dark m-4`}
                        data-action={"interacted"}
                        data-object={"content"}
                        data-ui-access-point={"TS Contact Form"}
                        data-ui-action={"clicked"}
                        data-ui-object={"button"}
                        data-ui-object-detail={"Submit"}                         
                    />
                </div>
            </form>
        </>
    )
}

export default Eloqua
